// extracted by mini-css-extract-plugin
export var container = "_d6-0";
export var infoIcon = "_d6-2";
export var titleRowCol = "_d6-1";